import { forEach } from 'lodash';
import * as React from 'react';
import Authorisation from '../../screens/Authorisation';

export interface Props {
    match?: {
        params: {
            candidateId: string;
            documentId: string;
            firstName: string;
            lastName: string;
        }
    };
    location?: {
        search: string;
    };
}

class AuthorisationContainer extends React.Component<Props> {
    private readonly params: {
        candidateId: string;
        documentId: string;
        firstName: string;
        lastName: string;
    } = {
        candidateId: '',
        documentId: '',
        firstName: '',
        lastName: '',
    };

    constructor(props: Props) {
        super(props);
        this.getQueryParams();
    }

    private getQueryParams() {
        const query: string = this.props.location && this.props.location.search.substring(1) || '';
        const variables = query.split('&');
        forEach(variables, variable => {
            const pair = variable.split('=');
           this.params[pair[0]] = pair[1];
        });
    }

    public render() {
        const {
            candidateId,
            documentId,
            firstName,
            lastName
        } = this.params;

        return (
            <div className='authorisation-container'>
                <Authorisation  candidateId={candidateId}
                                documentId={documentId}
                                firstName={firstName}
                                lastName={lastName}/>
            </div>
        );
    }
}

export default AuthorisationContainer;



// WEBPACK FOOTER //
// ./src/containers/Authorisation/index.tsx